import { jsxs, jsx } from "react/jsx-runtime";
import "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { DetailedIconPiggybank, DetailedIconHome } from "@zillow/constellation";
import { AFFORDABILITY_DTI_MAX } from "../AffordabilityCalculator.utils.esm.js";
const AFFORDABILITY_IMG_MIN = 40;
const AFFORDABILITY_IMG_MAX = 100;
const AFFORDABILITY_SIZE = AFFORDABILITY_IMG_MAX - AFFORDABILITY_IMG_MIN;
const StyledAffordabilityGraphicImagesContainer = styled.div.withConfig({
  displayName: "AffordabilityGraphic__StyledAffordabilityGraphicImagesContainer",
  componentId: "sc-19xz5ow-0"
})(["min-height:100px;position:relative;margin-bottom:5px;"]);
const StyledAffordabilityGraphic = styled.div.withConfig({
  displayName: "AffordabilityGraphic__StyledAffordabilityGraphic",
  componentId: "sc-19xz5ow-1"
})(["position:absolute;bottom:0;svg{width:", "px;height:", "px;max-height:100px;max-width:100px;}"], (props) => props.width, (props) => props.height);
const StyledAffordabilityGraphicPiggy = styled(StyledAffordabilityGraphic).withConfig({
  displayName: "AffordabilityGraphic__StyledAffordabilityGraphicPiggy",
  componentId: "sc-19xz5ow-2"
})(["left:20px;"]);
const StyledAffordabilityGraphicHouse = styled(StyledAffordabilityGraphic).withConfig({
  displayName: "AffordabilityGraphic__StyledAffordabilityGraphicHouse",
  componentId: "sc-19xz5ow-3"
})(["right:20px;"]);
function getImageRatios({
  customPayment,
  monthlyPayment,
  maximumPayment,
  dti
}) {
  let ratio;
  if (customPayment) {
    ratio = monthlyPayment / maximumPayment;
  } else {
    ratio = dti / AFFORDABILITY_DTI_MAX;
  }
  const big = AFFORDABILITY_IMG_MIN + AFFORDABILITY_SIZE * ratio;
  const small = AFFORDABILITY_IMG_MAX - AFFORDABILITY_SIZE * ratio;
  return {
    big,
    small
  };
}
function AffordabilityGraphic({
  customPayment,
  monthlyPayment,
  maximumPayment,
  dti
}) {
  const imageRatios = getImageRatios({
    customPayment,
    monthlyPayment,
    maximumPayment,
    dti
  });
  return /* @__PURE__ */ jsxs(StyledAffordabilityGraphicImagesContainer, { children: [
    /* @__PURE__ */ jsx(StyledAffordabilityGraphicPiggy, { width: imageRatios.small, height: imageRatios.small, children: /* @__PURE__ */ jsx(DetailedIconPiggybank, { alt: "piggy bank" }) }),
    /* @__PURE__ */ jsx(StyledAffordabilityGraphicHouse, { width: imageRatios.big, height: imageRatios.big, children: /* @__PURE__ */ jsx(DetailedIconHome, { alt: "house" }) })
  ] });
}
AffordabilityGraphic.propTypes = {
  customPayment: PropTypes.number,
  monthlyPayment: PropTypes.number,
  maximumPayment: PropTypes.number,
  dti: PropTypes.number
};
export {
  AffordabilityGraphic as default
};
